module.exports = __webpack_public_path__ + "img/avatar2.93db2b2d.png";